export const languageOptions: LanguageOptions[] = [
  {
    text: 'English',
    value: 'en',
    country_code: 'EN'
  },
  {
    text: 'Nederlands',
    value: 'nl',
    country_code: 'NL'
  },
  {
    text: 'Deutsch',
    value: 'de',
    country_code: 'DE'
  },
  {
    text: 'Français',
    value: 'fr',
    country_code: 'FR'
  },
];


export interface LanguageOptions {
  text?: string,
  value?: string,
  country_code?: string,
}